
// FOR TESTING (add Javis if different):
const LOCAL_DOMAINS = ["localhost", "127.0.0.1", "8.8.8.8",];

let ajax_base			= "/ajax/";

if (LOCAL_DOMAINS.includes(window.location.hostname)) {
  ajax_base			= "http://localhost/rutadeltoro/app/ajax/";
  console.warn("running on localhost");
} 

const ajax = {

  login: "login.php",                   
  passwordreset: "password_reset.php",    // Not used 
  passwordchange: "password_change.php", // Not used

  mycart: "user_cart.php",
  order: "place_order.php",

  publi: "publicidad.php",
  agenda: "agenda.php",
 
  get(a: string): string {
    return ajax_base + (this as any)[a];
  },

  sync_step: 0,

}


export { ajax };